// extracted by mini-css-extract-plugin
export default {"cls1":"ULnwMtskF4RlsA5NoYFc","cls2":"al8F97qnMN0VpfhJ22Bw ULnwMtskF4RlsA5NoYFc"};